package com.castly.admin.dto

import kotlinx.serialization.Serializable

/**
 * Unified response structure for both podcasts and audiobooks (Feature 014)
 * All content types share this structure with type-specific optional fields
 *
 * Frontend copy with String-based UUIDs (Kotlin/JS compatible)
 */
@Serializable
data class ContentResponse(
    val id: String,                             // UUID as string
    val type: String,                           // "podcast" | "audiobook"
    val title: String,
    val description: String? = null,
    val coverImageUrl: String? = null,
    val creators: List<CreatorResponse> = emptyList(),
    val tags: List<TagResponse> = emptyList(),

    // Podcast-specific fields (null for audiobooks)
    val seasonCount: Int? = null,

    // Audiobook-specific fields (null for podcasts)
    val isbn: String? = null,
    val publicationYear: Int? = null,

    // Common metadata
    val episodeCount: Int = 0,
    val createdAt: String,                      // ISO 8601 timestamp
    val updatedAt: String,                      // ISO 8601 timestamp

    // Engagement
    val isLiked: Boolean = false
)
